import React, { useState } from 'react';
import { Card, Section } from '../shared/primitives';
import { ERACS_TYPES, ERACS_READY, eracsPathwayFor } from '../../../data/hospitals/thiEracs';

/** Enhanced recovery pathway, one tab per procedure type */
const EnhancedRecovery = () => {
  const [tab, setTab] = useState(ERACS_TYPES[0].id);
  const current = ERACS_TYPES.find((t) => t.id === tab);
  const ready = ERACS_READY.includes(tab);
  const pathway = ready ? eracsPathwayFor(tab) : [];

  return (
    <div className="space-y-5">
      <div className={`bg-gray-100 dark:bg-gray-800 rounded-xl p-1 grid gap-1 ${ERACS_TYPES.length === 3 ? 'grid-cols-3' : 'grid-cols-4'}`} role="tablist">
        {ERACS_TYPES.map((t) => (
          <button
            key={t.id}
            role="tab"
            aria-selected={tab === t.id}
            onClick={() => { setTab(t.id); }}
            className={`py-2 px-1 rounded-lg text-xs font-semibold transition-all ${
              tab === t.id ? 'bg-white dark:bg-gray-700 text-gray-900 dark:text-white shadow-sm' : 'text-gray-600 dark:text-gray-400'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {ready ? (
        pathway.map((cat) => (
          <Section key={cat.name} title={cat.name}>
            <Card>
              {cat.sections.map((sec) => (
                <div key={sec.main} className="px-4 py-3">
                  <div className="text-[15px] font-medium text-gray-900 dark:text-white">{sec.main}</div>
                  <ul className="mt-1 space-y-1">
                    {sec.items.map((item) => (
                      <li key={item} className="text-sm text-gray-600 dark:text-gray-300 leading-snug pl-3 relative before:content-[''] before:absolute before:left-0 before:top-[0.55em] before:w-1 before:h-1 before:rounded-full before:bg-gray-400">
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </Card>
          </Section>
        ))
      ) : (
        <Section title={`${current.label} pathway`}>
          <Card>
            <div className="px-4 py-4 text-sm text-gray-400 dark:text-gray-500 italic">
              Enhanced recovery for {current.label.toLowerCase()} cases is still being written.
            </div>
          </Card>
        </Section>
      )}
    </div>
  );
};

export default EnhancedRecovery;
